import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

var listaunidep=[];
export default function  ParadaMap (props) {
    const [statelista, setalista]=React.useState([]);
const [satecentroadm,setacentroadm]=React.useState({
    id:''
});
const [unidadedep,setaunidadedep]=React.useState();
const [statecampi,setstatecampi]=React.useState("");
    React.useEffect (()=>{
        console.log("valor requirid inidep ", props.requer)
        setacentroadm(props.centroadm);
        setstatecampi(props.campi);
        
            })


    React.useEffect(() => {
        var nivel = props.nivel;
        
        if (nivel==1) {
           
            
            firebase.firestore().collection("departamentos").where('status', '==',true).where('campi', '==', statecampi)
        .get()
        .then(function(querySnapshot) {
            listaunidep=[];
            querySnapshot.forEach(function(doc) {
                listaunidep.push({id: doc.id, label: doc.data().depnome, codunidadetransporte:doc.data().codunidadetransporte, codcentroadm: doc.data().codcentroadm});
            })
            setalista(listaunidep)
          
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de transporte: ", error);
            alert('Não foi Possível carregar as unidades de transporte.');
        });
         
        } else {
            if (nivel==2) {
                firebase.firestore().collection("departamentos").where('status', '==', true).where('codcentroadm', '==', satecentroadm.id)
        .get()
        .then(function(querySnapshot) {
            listaunidep=[];
            querySnapshot.forEach(function(doc) {
                listaunidep.push({id: doc.id, label: doc.data().depnome,codcentroadm:satecentroadm.id, codunidadetransporte:satecentroadm.codunidadetransporte});
            })
            setalista(listaunidep)
            
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de transporte: ", error);
            alert('Não foi Possível carregar as unidades de transporte.');
        });
         
            }
            
        }
        
        
        
        

        

    },[satecentroadm,statecampi])

    const handleuniade=(event,value)=>(
        
        props.setaunidadedep(value)
        

    )

    return(
        <Autocomplete onChange={handleuniade}
                    
                    value={unidadedep}
                    id="combounidadetchef"
                    options={statelista}
                    getOptionLabel={(option) => option.label}
                    getOptionSelected={(option, value) => option.id === value.id}
                    renderInput={(params) => <TextField {...params}  required={props.requer}  label="Unidade/ Departamento" variant="outlined" />}
                />
                
)
}